export default "__VITE_ASSET__74bcaea0__"